// The Loyalty page's tabs, as they appear in its ?tab= query, so other pages can link to one.
export const LOYALTY_TABS = {
  SETTINGS: 'settings',
  TIERS: 'tiers',
  RULES: 'rules',
  OFFERS: 'offers',
  CUSTOMERS: 'customers',
  INFO: 'info',
  COUPONS: 'coupons',
};

export const LOYALTY_COUPONS_TAB = LOYALTY_TABS.COUPONS;
